// extracted by mini-css-extract-plugin
export default {"main_div":"Searchbar_main_div__pW6wG","input_box":"Searchbar_input_box__SGLD4"};